import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Google OAuth may redirect to http://localhost:3000/?code=...&state=...
 * Forward to /google-drive-callback so token exchange runs once.
 */
const GoogleOAuthRedirectHandler = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");
    if (!code || !state) return;
    if (location.pathname.includes("google-drive-callback")) return;
    navigate(`/google-drive-callback${location.search}`, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return children;
};

export default GoogleOAuthRedirectHandler;
